import { snakeCase } from 'lodash'
import Clonable from '../../../../utils/entities/clonable'

export class OverlaySettings extends Clonable {
  constructor ({ displayWeekNumbers = true, displayMonths = true, displayContent = true, displayCustomColors = true, displayGrid = true, displayHighlightedColumns = true } = {}) {
    super()
    this.displayGrid = displayGrid
    this.displayMonths = displayMonths
    this.displayWeekNumbers = displayWeekNumbers
    this.displayContent = displayContent
    this.displayCustomColors = displayCustomColors
    this.displayHighlightedColumns = displayHighlightedColumns
  }

  toOptions (translationPrefix) {
    return Object.entries(this).map(([key, value]) => ({
      name: key,
      label: translationPrefix + snakeCase(key),
      isSelected: value
    }))
  }
}

//#region Quotas + Desiderata
export class QuotasSettings extends OverlaySettings {
  constructor({ displayContentSize = true, ...settings } = {}) {
    super({ ...settings })
    this.displayContentSize = displayContentSize
  }
}

export class InstitutionsQuotasSettings extends QuotasSettings {
  constructor ({ displayPlacesRequests = true, filterQuotasBySchools = false, filterPlacesRequestsBySchools = true, ...settings } = {}) {
    super({ ...settings })
    this.displayPlacesRequests = displayPlacesRequests
    this.filterQuotasBySchools = filterQuotasBySchools
    this.filterPlacesRequestsBySchools = filterPlacesRequestsBySchools
  }
}

export class SchoolQuotasSettings extends QuotasSettings {
  constructor ({ ...settings } = {}) {
    super({ ...settings })
  }
}
//#endregion

//#region Internships places occupancy
export class InternshipsSettings extends OverlaySettings {
  constructor ({ displayQuotas = true, displaySectionsExceptions = true, displayStatuses = true, displayConvention = true, ...settings } = {}) {
    super({ ...settings })
    this.displayQuotas = displayQuotas
    this.displaySectionsExceptions = displaySectionsExceptions
    this.displayStatuses = displayStatuses
    this.displayConvention = displayConvention
  }
}
//#endregion
